import { User, UserAccessToken, UserBrand, UserPreferences } from "@/core/entities/user";
import { IAuthRepository } from "@/core/repositories/auth";
import { IUserRepository } from "@/core/repositories/user";
import AuthService from "@/core/services/Auth.service";

export class UserRepository implements IUserRepository {
  constructor(private readonly authRepository: IAuthRepository) {}

  async getUser(): Promise<User | null> {
    const userInfo = await this.authRepository.getUserInfoFromStorage();
    if (!userInfo) return null;
    return new User(userInfo);
  }

  async getUserPreferences(): Promise<UserPreferences> {
    return {
      theme: "light",
    };
  }

  async getUserAccessToken(): Promise<UserAccessToken | null> {
    const userAccessToken = await AuthService.getInstance().getUserAccessToken();
    if (!userAccessToken) return null;
    return new UserAccessToken({
      accessToken: userAccessToken,
    });
  }

  async getUserBrands(): Promise<UserBrand[]> {
    const userBrands = await this.authRepository.getUserBrandsFromStorage();
    if (!userBrands) return [];
    return userBrands.map(brand => new UserBrand(brand));
  }
}
